var API_DOMAIN  = "https://sugunacrackers.com/api";

export default API_DOMAIN